import * as actions from "./actions";
import mutations from "./mutations";

export const state = {};

export default {
  actions,
  mutations,
  state
};
